import React from "react";

/**
 * FloatingHelpButton — the always-visible "?" in the bottom-right corner of
 * every authenticated page. Opens the HelpPanel (contact support / feedback /
 * feature requests). Mounted app-wide in App.js, outside the Routes, so it
 * shows on all logged-in pages including /majlis; public pages never render it.
 *
 * Props: onClick.
 */
export default function FloatingHelpButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      aria-label="Help and support"
      title="Help & support"
      className="dark-scope fixed bottom-4 right-4 z-40 w-12 h-12 rounded-full shadow-soft-lg flex items-center justify-center text-lg font-bold transition hover:brightness-110"
      style={{
        background: "var(--gold-bright, #d4a72c)",
        color: "var(--ink, #1a1a2e)",
      }}
    >
      ?
    </button>
  );
}
